var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.333 8c0-.368.299-.667.667-.667h12a.667.667 0 110 1.334H6A.667.667 0 015.333 8zm0 4c0-.368.299-.667.667-.667h12a.667.667 0 110 1.334H6A.667.667 0 015.333 12zM6 15.333a.667.667 0 100 1.334h12a.667.667 0 000-1.334H6z",
    fill: "#231A1A"
  })));
}

export default SvgMenu;